export default "__VITE_ASSET__DGJVIgVY__"